import { defineComponent as _defineComponent } from 'vue'
import { APP_NAME } from '@/plugins/config';

export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingTabFinish',
  setup(__props) {


return { __sfc: true,APP_NAME }
}

})